interface ChatDeltaScheduler {
  schedule: (callback: () => void) => number
  cancel: (id: number) => void
}

const createChatDeltaBuffer = (
  onFlush: (text: string) => void,
  { schedule, cancel }: ChatDeltaScheduler,
) => {
  let buffered = ''
  let frameId: number | null = null

  const cancelFrame = () => {
    if (frameId === null) return
    cancel(frameId)
    frameId = null
  }

  const flush = () => {
    cancelFrame()
    if (!buffered) return

    const text = buffered
    buffered = ''
    onFlush(text)
  }

  const push = (text: string) => {
    buffered += text
    if (frameId === null) frameId = schedule(flush)
  }

  const discard = () => {
    cancelFrame()
    buffered = ''
  }

  return { push, flush, discard }
}

export type { ChatDeltaScheduler }
export { createChatDeltaBuffer }
